import { alpha, Drawer, InputBase, List, Typography } from "@mui/material";
import styled, { css } from "styled-components";
import { theme } from "styles/mui-config";
import MuiAppBar from "@mui/material/AppBar";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";

export const StyledDrawer = styled(Drawer)`
  width: ${(props) => props.$drawerWidth}px;
  flex-shrink: 0;
  & .MuiDrawer-paper {
    width: ${(props) => props.$drawerWidth}px;
    box-sizing: border-box;
    background-color: ${theme.palette.primary.main};
  }
`;
////////////////////////////////////////
export const StyledAccordion = styled(Accordion)`
  background: transparent !important;
  box-shadow: none !important;
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0 !important;
`;
export const StyledSetting = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
////////////////////////////////////////
export const StyledList = styled(List)`
  background-color: ${theme.palette.primary.main};
  & div {
    color: white;
  }
`;

////////////////// Search /////////////////////
export const SearchBoxWrapper = styled.div`
  padding: ${theme.spacing(0, 2)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
`;

//////////////////////////////////////////
export const StyledInputBase = styled(InputBase)`
  color: inherit;
  & .MuiInputBase-input {
    padding: ${theme.spacing(1, 1, 1, 0)};
    color: white !important;
    // vertical padding + font size from searchIcon
    padding-right: calc(1em + +${theme.spacing(4)});
    transition: 0.3s;
    width: 100%;
    ::placeholder {
      color: white;
    }
    &:hover {
      background-color: ${alpha(theme.palette.common.white, 0.3)};
    }
    &:focus {
      background-color: ${alpha(theme.palette.common.white, 0.3)};
    }
    ${theme.breakpoints.up("sm")} {
      width: 150px;
    }
  }
`;

//////////////////////////////////
export const StyledSearch = styled.div`
  position: relative;
  border-radius: ${theme.shape.borderRadius}px;
  background-color: ${alpha(theme.palette.common.white, 0.2)};
  margin-left: 0;
  width: 100%;
  transition: 0.3s;
  ${theme.breakpoints.up("sm")} {
    margin-left: ${theme.spacing(1)};
    width: auto;
  }
  display: flex !important;
  flex-direction: row-reverse;
`;

/////////////////////////////////////
export const StyledTypo = styled(Typography)`
  flex-grow: 1;
  ${theme.breakpoints.down("sm")} {
    display: none;
  }
`;
///////////////////////////////////

export const StyledDrawerHeader = styled.div`
  background: ${theme.palette.primary.main};
  display: flex;
  align-items: center;
  padding: ${theme.spacing(0, 1)};
  // necessary for content to be below app bar
  ${theme.mixins.toolbar}
  justify-content: flex-end;
`;

///////////////////////////////////
const isAppBarOpen = ({ open }) => {
  if (open) {
    return css`
      width: calc(100% - +${(props) => props.$drawerWidth}px) !important;
      margin-right: ${(props) => props.$drawerWidth}px !important;
      transition: ${theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      })} !important;
    `;
  }
};

export const StyledAppBar = styled(MuiAppBar)`
  transition: ${theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  })} !important;
  ${isAppBarOpen}
`;

///////////////////////////////////////////////
const isMainOpen = ({ open }) => {
  if (open) {
    return css`
      transition: ${theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      })};
      margin-right: 0;
    `;
  }
};
export const StyledMain = styled.main`
  flex-grow: 1;
  transition: ${theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  })};
  width: 100%;
  margin-right: -${(props) => props.$drawerWidth}px;
  ${isMainOpen}
`;
